export default function (campaign, config) {
  const {
    campaignChannel,
    campaigncategory,
    selected_market_abr,
    selected_brand_abr,
    businessunit,
    business_area,
    maintarget,
    businesstype,
    namecomputed,
    utm_source,
    utm_medium,
    utm_campaign,
    utm_content,
    email_list,
    sms_list,
    push_list,
    alwaysOn,
    brands,
    camperContribution,
    ccdbReportEnabled,
    ccdbReportType,
    ccCallsEndDate,
    ccCallsStartDate,
    ccExtractionDaysFreq,
    ccMaxRecordsToExtract,
    ccScript,
    channelPriority,
    contentClassification,
    contributionType,
    cscEngagementLevel,
    description,
    disableOrchestration,
    endDate,
    finality,
    jeepWave,
    manager,
    marketCodes,
    masterKey,
    name,
    onlyHeader,
    ppExtractionDaysFreq,
    ppExtractionEndDate,
    ppExtractionStartDate,
    ppMaxRecordsToExtract,
    ppProviderId,
    ppTemplateFilename,
    ppUrl1,
    ppUrl2,
    ppUrl3,
    preview,
    recordType,
    segmentType,
    startDate,
    status,
    touchpoint,
    type
  } = campaign

  return {
    campaignChannel,
    campaigncategory,
    selected_market_abr,
    selected_brand_abr,
    businessunit,
    business_area,
    maintarget,
    businesstype,
    namecomputed,
    utm_source,
    utm_medium,
    utm_campaign,
    utm_content,
    email_list,
    sms_list,
    push_list,
    alwaysOn,
    brands,
    camperContribution,
    ccdbReportEnabled,
    ccdbReportType,
    ccCallsEndDate: ccCallsEndDate || null,
    ccCallsStartDate: ccCallsStartDate || null,
    ccExtractionDaysFreq,
    ccMaxRecordsToExtract,
    ccScript: ccScript || null,
    channelPriority: channelPriority || null,
    contentClassification: contentClassification || null,
    contributionType: contributionType || null,
    cscEngagementLevel,
    description,
    disableOrchestration,
    endDate: endDate || null,
    finality,
    jeepWave: jeepWave || [],
    manager,
    marketCodes,
    masterKey,
    name,
    onlyHeader,
    ppExtractionDaysFreq,
    ppExtractionEndDate: ppExtractionEndDate || null,
    ppExtractionStartDate: ppExtractionStartDate || null,
    ppMaxRecordsToExtract,
    ppProviderId,
    ppTemplateFilename,
    ppUrl1,
    ppUrl2,
    ppUrl3,
    preview,
    recordType,
    segmentType,
    startDate: startDate || null,
    status,
    touchpoint,
    type,
    config: _buildConfig(campaign, config)
  }
}

function _buildConfig (campaign, config) {
  const configObject = {}
  if (campaign.config.campaignData) {
    configObject.campaignData = campaign.config.campaignData
  }

  return configObject
}
